import { render, staticRenderFns } from "./ExhibitionSearchDetail.vue?vue&type=template&id=c5937ea4&scoped=true&"
import script from "./ExhibitionSearchDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionSearchDetail.vue?vue&type=style&index=0&id=c5937ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5937ea4",
  null
  
)

export default component.exports